import { FormikProps } from 'formik';
import { useFormActions } from '../hooks/useFormActions';
import { useFormField } from '../hooks/useFormField';
import { FormActions } from '../types/FormActions';

export const createFormHooks = <FormValuesT, >() => {
  return {
    useFormField: useFormField as <R>(callback: (formikState: FormikProps<FormValuesT>) => R) => R,
    useFormActions: useFormActions as () => FormActions<FormValuesT>,
  };
};